/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
module.exports = __webpack_require__(2);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var poltBtn = document.querySelectorAll('.polt-btn');
var alphaBtn = document.querySelectorAll('.alpha-btn');
var betaBtn = document.querySelectorAll('.beta-btn');
var test = document.querySelectorAll('.test');
var menuButton = document.getElementById('bouton');
var menuMobile = document.getElementById('menu-mobile');
var opacity = document.querySelectorAll('a, .link');

if (window.matchMedia("(max-width: 768px)").matches) {
    cellWidth = 40;
    cellHeight = 40;
    var anchors = document.querySelectorAll('#menu-mobile a');
} else {
    var cellWidth = 120,
        cellHeight = 120;
    var anchors = document.querySelectorAll('#menu-desktop a');
}

// Liens actifs

window.onscroll = onScroll;

function onScroll() {
    var removeActiveClass = function removeActiveClass(elements) {
        for (var i = 0; i < elements.length; ++i) {
            elements[i].classList.remove('active');
        }
    };
    var previousRefElement = null;
    for (var i = 0; i < anchors.length; ++i) {
        var currentRefElement = document.getElementById(anchors[i].getAttribute('href').substring(1));
        var currentRefElementTop = currentRefElement.getBoundingClientRect().top - 10;
        if (currentRefElementTop <= 0) {
            previousRefElement = anchors[i];
            if (i == anchors.length - 1) {
                removeActiveClass(anchors);
                anchors[i].classList.add("active");
            }
        } else {
            removeActiveClass(anchors);
            previousRefElement.classList.add("active");
            break;
        }
    }
}

// Menu mobile

menuButton.addEventListener('click', menuShowing);

if (window.matchMedia("(max-width: 768px)").matches) {
    for (var i = 0; i < anchors.length; ++i) {
        anchors[i].addEventListener('click', menuShowing);
    };
}

function menuShowing() {
    menuMobile.classList.toggle('showing');
    for (var i = 0; i < opacity.length; ++i) {
        opacity[i].classList.toggle('index-fix');
    };
}

// Effets titres

function changeStylePolt(e) {
    e.classList.toggle('polt');e.classList.remove('alpha');e.classList.remove('beta');
}
function changeStyleAlpha(e) {
    e.classList.toggle('alpha');;e.classList.remove('polt');e.classList.remove('beta');
}
function changeStyleBeta(e) {
    e.classList.toggle('beta');;e.classList.remove('alpha');e.classList.remove('polt');
}

var _loop = function _loop(l, _i) {
    poltBtn[_i].addEventListener('click', function () {
        poltBtn[_i].classList.toggle('active');
        betaBtn[_i].classList.remove('active');
        alphaBtn[_i].classList.remove('active');
        changeStylePolt(test[_i]);
    });
};

for (var _i = 0, l = poltBtn.length; _i < l; _i++) {
    _loop(l, _i);
}

var _loop2 = function _loop2(l, _i2) {
    alphaBtn[_i2].addEventListener('click', function () {
        alphaBtn[_i2].classList.toggle('active');
        poltBtn[_i2].classList.remove('active');
        betaBtn[_i2].classList.remove('active');
        changeStyleAlpha(test[_i2]);
    });
};

for (var _i2 = 0, l = alphaBtn.length; _i2 < l; _i2++) {
    _loop2(l, _i2);
}

var _loop3 = function _loop3(l, _i3) {
    betaBtn[_i3].addEventListener('click', function () {
        betaBtn[_i3].classList.toggle('active');
        poltBtn[_i3].classList.remove('active');
        alphaBtn[_i3].classList.remove('active');
        changeStyleBeta(test[_i3]);
    });
};

for (var _i3 = 0, l = betaBtn.length; _i3 < l; _i3++) {
    _loop3(l, _i3);
}

// Glyphset

var cellCount = 100,
    cellMarginTop = 1,
    cellMarginBottom = 8,
    cellMarginLeftRight = 1,
    glyphMargin = 3,
    pixelRatio = window.devicePixelRatio || 1;

var pageSelected, font, fontScale, fontSize, fontBaseline, glyphScale, glyphSize, glyphBaseline;

function enableHighDPICanvas(canvas) {
    if (typeof canvas === 'string') {
        canvas = document.getElementById(canvas);
    }
    var pixelRatio = window.devicePixelRatio || 1;
    if (pixelRatio === 1) return;
    var oldWidth = canvas.width;
    var oldHeight = canvas.height;
    canvas.width = oldWidth * pixelRatio;
    canvas.height = oldHeight * pixelRatio;
    canvas.style.width = oldWidth + 'px';
    canvas.style.height = oldHeight + 'px';
    canvas.getContext('2d').scale(pixelRatio, pixelRatio);
}

function showErrorMessage(message) {
    var el = document.getElementById('message');
    if (!message || message.trim().length === 0) {
        el.style.display = 'none';
    } else {
        el.style.display = 'block';
    }
    el.innerHTML = message;
}

function formatUnicode(unicode) {
    unicode = unicode.toString(16);
    if (unicode.length > 4) {
        return ("000000" + unicode.toUpperCase()).substr(-6);
    } else {
        return ("0000" + unicode.toUpperCase()).substr(-4);
    }
}

var arrowLength = 10,
    arrowAperture = 4;

function renderGlyphItem(canvas, glyphIndex) {
    var cellMarkSize = 4;
    var ctx = canvas.getContext('2d');
    var font = window.font;
    ctx.clearRect(0, 0, cellWidth, cellHeight);
    if (glyphIndex >= font.numGlyphs) return;

    var glyph = font.glyphs.get(glyphIndex),
        glyphWidth = glyph.advanceWidth * fontScale,
        xmin = (cellWidth - glyphWidth) / 2,
        xmax = (cellWidth + glyphWidth) / 2,
        x0 = xmin;

    ctx.fillStyle = '#FF0000';
    glyph.draw(ctx, x0, fontBaseline, fontSize);
}

function displayGlyphPage(pageNum) {
    pageSelected = pageNum;
    document.getElementById('p' + pageNum).className = 'page-selected';
    var firstGlyph = pageNum * cellCount;
    for (var i = 0; i < cellCount; i++) {
        renderGlyphItem(document.getElementById('g' + i), firstGlyph + i);
    }
}

function pageSelect(event) {
    document.getElementsByClassName('page-selected')[0].className = '';
    displayGlyphPage(+event.target.id.substr(1));
}

function initGlyphDisplay() {
    var glyphBgCanvas = document.getElementById('glyph-bg'),
        font = window.font,
        w = glyphBgCanvas.width / pixelRatio,
        h = glyphBgCanvas.height / pixelRatio,
        glyphW = w - glyphMargin * 2,
        glyphH = h - glyphMargin * 2,
        head = font.tables.head,
        maxHeight = head.yMax - head.yMin,
        ctx = glyphBgCanvas.getContext('2d');

    glyphScale = Math.min(glyphW / (head.xMax - head.xMin), glyphH / maxHeight);
    glyphSize = glyphScale * font.unitsPerEm;
    glyphBaseline = glyphMargin + glyphH * head.yMax / maxHeight;

    function hline(text, yunits) {
        var ypx = glyphBaseline - yunits * glyphScale;
        ctx.fillText(text, 2, ypx + 3);
        ctx.fillRect(80, ypx, w, 1);
    }

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#FF0000';
    hline('Baseline', 0);
    hline('yMax', font.tables.head.yMax);
    hline('yMin', font.tables.head.yMin);
    hline('Ascender', font.tables.hhea.ascender);
    hline('Descender', font.tables.hhea.descender);
    hline('Typo Ascender', font.tables.os2.sTypoAscender);
    hline('Typo Descender', font.tables.os2.sTypoDescender);
}

function onFontLoaded(font) {
    window.font = font;

    var w = cellWidth - cellMarginLeftRight * 2,
        h = cellHeight - cellMarginTop - cellMarginBottom,
        head = font.tables.head,
        maxHeight = head.yMax - head.yMin;
    fontScale = Math.min(w / (head.xMax - head.xMin), h / maxHeight);
    fontSize = fontScale * font.unitsPerEm;
    fontBaseline = cellMarginTop + h * head.yMax / maxHeight;

    var pagination = document.getElementById("pagination");
    pagination.innerHTML = '';
    var fragment = document.createDocumentFragment();
    var numPages = Math.ceil(font.numGlyphs / cellCount);
    for (var i = 0; i < numPages; i++) {
        var link = document.createElement('span');
        var lastIndex = Math.min(font.numGlyphs - 1, (i + 1) * cellCount - 1);
        link.textContent = i * cellCount + '-' + lastIndex;
        link.id = 'p' + i;
        link.addEventListener('click', pageSelect, false);
        fragment.appendChild(link);
        // A white space allows to break very long lines into multiple lines.
        // This is needed for fonts with thousands of glyphs.
        // fragment.appendChild(document.createTextNode(' '));
    }
    pagination.appendChild(fragment);

    initGlyphDisplay();
    displayGlyphPage(0);
    // displayGlyph(-1);
    // displayGlyphData(-1);
}

function prepareGlyphList() {

    var marker = document.getElementById('glyph-list-end'),
        parent = marker.parentElement;
    for (var i = 0; i < cellCount; i++) {
        var canvas = document.createElement('canvas');
        canvas.width = cellWidth;
        canvas.height = cellHeight;
        canvas.className = 'item';
        canvas.id = 'g' + i;
        enableHighDPICanvas(canvas);
        parent.insertBefore(canvas, marker);
    }
}

var fontFileName = 'font/Karrik-Regular.ttf';

enableHighDPICanvas('glyph-bg');
enableHighDPICanvas('glyph');

prepareGlyphList();
opentype.load(fontFileName, function (err, font) {
    var amount, glyph, ctx, x, y, fontSize;
    if (err) {
        showErrorMessage(err.toString());
        return;
    }
    onFontLoaded(font);
}, { lowMemory: true });

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 14f0c0e716d8e1bb334d.js